var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67518 2.55939C3.89744 2.1019 2.91699 2.66266 2.91699 3.56498V11.152C2.91699 12.0543 3.89744 12.6151 4.67518 12.1576L11.1242 8.36407C11.891 7.91299 11.891 6.804 11.1242 6.3529L4.67518 2.55939Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay01);
export default __webpack_public_path__ + "static/media/play-01.5e70c9e9aa497969929b41094ac5987d.svg";
export { ForwardRef as ReactComponent };